module.exports = __webpack_public_path__ + "static/img/Invitation-bottom-bg.b24695f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invitation/Invitation-bottom-bg.png
// module id = DJMU
// module chunks = 2